import { useForm } from 'react-hook-form';
import Loader from 'react-loader-spinner';
import { Button, Col, Form, Modal, Table } from 'react-bootstrap';
import { Accordion, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { Check2All, CheckLg, PersonPlus, Search } from "react-bootstrap-icons";
import React, { useEffect, useState, useRef } from 'react';
import { getAllProvinces, getCityList } from '../../store/api/LocationAPI';
import { searchCustomer4Modal, checkNationalCode, addNewCustomer } from '../../CRM/store/api/CustomerApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { isWebApp, setErrorDialog } from '../../store/api/CommonFunctions';
import BihamtaTable from "../BihamtaTable";
/**
 * 
 * @param {*} props nationalCodeIsRequired, setCustomerPopup, 
 * popData: { show, value, setCustomerData, setCustomerLocation, invoiceCustomers, justStaff, justForSelect }
 * @returns 
 */
const ModalSelectCustomer = (props) => {
    const { handleSubmit, register } = useForm();
    const { nationalCodeIsRequired, setCustomerPopup, popData } = props;
    const { show, value, setCustomerData, setCustomerLocation, invoiceCustomers, justStaff, justForSelect, defaultAccType } = popData;
    const { provinceList, cityList } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer?.provinceList,
            cityList: state.locationDataReducer?.cityList,
            zoneList: state.locationDataReducer?.zoneList,
            currentLocation: state.locationDataReducer?.currentLocation
        }
    });

    const [isPending, setPending] = useState(false);
    const [customerList, getData] = useState([]);
    const customerData = useRef({});
    const [custType, setCustType] = useState('');
    const [err, setError] = useState({});
    const title = justStaff ? "تکنسین/نماینده" : "طرف حساب";
    const dispatch = useDispatch();
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: false, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "Code", colTitle: "کد " + title, showInMobile: true, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "FirstName+Name", colTitle: "نام " + title,seprator:' ',colType:"string", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "Phone+Mobile", colTitle: "شماره تماس",colType:"string", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "NationalCode", colTitle: "شماره ملی", styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        { colName: "SubscriptionCode", colTitle: "شماره اشتراک", showCondition: () => invoiceCustomers, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} },
        {colName:"Address", colTitle:"نشانی", colType:"string", maxTextLength:50, hasTooltip:true, style:{fontSize:"10px"}},
        { colName: "CustOrPreCust", colTitle: "مشتری/بالقوه", showCondition: () => invoiceCustomers, styleCondition: (row) => row.IsBlackListed ? { color: "red" } : {} }
    ]
    function closeModal() {
        setCustomerData(null);
        setCustomerPopup({ show: false });
    }
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID));
    }
    const submit = (gotoCustomer) => {
        if (isPending) {
            return;
        }
        // const firstNameIsEmpty = custType !== "حقوقی" && (customerData.current.FirstName ?? "") === '';
        const nameIsEmpty = (customerData.current.Name ?? "") === '';
        const nationalIsEmpty = nationalCodeIsRequired && ((customerData.current.NationalCode ?? "") === '' || (customerData.current.Type !== 'حقوقی' && !checkNationalCode(customerData.current.NationalCode)));
        const addresIsEmpty = (customerData.current.Address ?? "") === '';
        const phoneOrMobileIsEmpty = (customerData.current.Phone ?? "") === '' && (customerData.current.Mobile ?? "") === '';
        //const provinceIsEmpty = (customerData.current.ProvinceID ?? "") === '';
        //const cityIsEmpty = (customerData.current.CityID ?? "") === '';
        const typeIsEmpty = (customerData.current.Type ?? "") === '';

        setError({
            Name: nameIsEmpty ? 'N' : null,
            NationalCode: nationalIsEmpty ? 'N' : null,
            Address: addresIsEmpty ? 'N' : null,
            Mobile: phoneOrMobileIsEmpty ? 'N' : null,
            // ProvinceID: provinceIsEmpty ? 'N' : null,
            // CityID: cityIsEmpty ? 'N' : null,
            Type: typeIsEmpty ? 'N' : null
        });
        if (nameIsEmpty || nationalIsEmpty || addresIsEmpty || phoneOrMobileIsEmpty /*|| provinceIsEmpty || cityIsEmpty*/ || typeIsEmpty /*|| firstNameIsEmpty*/) {
            return;
        }
        customerData.current.Cat = 3;

        const onAdd = (res) => {
            //res.Name = (res.FirstName ?? "") + " " + res.Name;

            setPending(false);
            select(res);
            if (gotoCustomer && res) {
                window.open("/CRM/AddEditCustomer/" + res.ID);
            }
        }
        setPending(true);
        dispatch(addNewCustomer(customerData.current, onAdd));
    }
    const search = (data) => {
        data.Take = data.Take ?? 10;
        data.Skip = 0;
        data.JustStaff = justStaff ?? false;
        data.InvoiceCustomers = invoiceCustomers;
        //data.IsBlackListed = false;
        searchCustomer4Modal(data, getData);
    }
    const select = (item) => {
        if (item.IsBlackListed) {
            setErrorDialog(dispatch, "این مشتری در لیست سیاه قرار دارد.", "انتخاب مشتری", 1200);
        }
        if (setCustomerData) {
            item.Name = (item.FirstName ? item.FirstName + " " : "") + item.Name;
            setCustomerData(item);
        }
        if (setCustomerLocation) {
            setCustomerLocation(item.ProvinceID, item.CityID);
        }
        customerData.current = {};
        setCustomerPopup({ show: false });
    }
    function inputKeyDown(e) {
        if (e.keyCode === 27) {
            closeModal();
        }
    }
    function changeCustomerType(type) {
        customerData.current.Type = type;
        setCustType(type);
    }
    useEffect(() => {
        if (show) {
            const inputCustName = document.getElementById("inputCustName");
            inputCustName.focus();
            if (value && value !== '') {
                inputCustName.value = value;
            }
            if (!provinceList || provinceList === "" || provinceList.length === 0)
                dispatch(getAllProvinces());
        }
    }, [show])
    return (
        <Modal show={show} size='lg' style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faListAlt} size='lg' /> &nbsp;
                    انتخاب {title} از لیست
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={closeModal} />
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <Accordion defaultActiveKey="1">
                    {!justStaff && !justForSelect &&
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "rgb(30 165 187)" }}>
                                <PersonPlus size={20} />&nbsp;
                                تعریف طرف حساب
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="Type" onChange={e => changeCustomerType(e.target.value)} >
                                                <option value="">نوع طرف حساب</option>
                                                <option value="حقوقی">حقوقی</option>
                                                <option value="مرد">مرد</option>
                                                <option value="زن">زن</option>
                                            </select>
                                            {err.Type && <small className="errors">انتخاب نوع اجباری است</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="Type" onChange={e => customerData.current.CustomerAccountType = e.target.value} defaultValue={defaultAccType === undefined ? true : defaultAccType}>
                                                <option value="">ماهیت طرف حساب</option>
                                                <option value={true}>بدهکار</option>
                                                <option value={false}>بستانکار</option>
                                            </select>
                                            {err.Type && <small className="errors">انتخاب نوع اجباری است</small>}
                                        </div>
                                        {custType !== "حقوقی" &&
                                            <div className="form-group col-md-4">
                                                <input className="form-control" type="text" placeholder="نام طرف حساب" onChange={e => customerData.current.FirstName = e.target.value} />
                                                {err.FirstName && <small className="errors">نام را وارد کنید</small>}
                                            </div>
                                        }
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="text" placeholder={(custType === "حقوقی" ? "نام" : "نام خانوادگی") + " طرف حساب"} onChange={e => customerData.current.Name = e.target.value} />
                                            {err.Name && <small className="errors">{custType === "حقوقی" ? "نام" : "نام خانوادگی"} را وارد کنید</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder={custType === "حقوقی" ? "شناسه ملی" : "کد ملی"} onChange={e => customerData.current.NationalCode = e.target.value}></input>
                                            {err.NationalCode && <small className="errors">{custType === "حقوقی" ? "شناسه ملی" : "کد ملی"} ملی معتبر نیست</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder="تلفن همراه" onChange={e => customerData.current.Mobile = e.target.value} />
                                            {err.Mobile && <small className="errors">تلفن همراه یا ثابت باید وارد شود</small>}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <input className="form-control" type="number" lang='en' placeholder="تلفن ثابت" onChange={e => customerData.current.Phone = e.target.value} />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="ProvinceID" onChange={e => { customerData.current.ProvinceID = e.target.value; loadCityList(e.target.value) }} >
                                                <option value="">انتخاب استان</option>
                                                {provinceList && Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        </div>
                                        <div className="form-group col-md-4">
                                            <select className="form-control" name="CityID" placeholder="شهر" onChange={e => customerData.current.CityID = e.target.value}>
                                                <option value="">انتخاب شهر</option>
                                                {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                            </select>
                                        </div>
                                        <Col md={4} className='form-group'>
                                            <Form.Control placeholder='کد اقتصادی' onChange={e => customerData.current.ComercialCode = e.target.value} />
                                        </Col>
                                        <Col md={4} className='form-group'>
                                            <Form.Control placeholder='کد پستی' onChange={e => customerData.current.PostalCode = e.target.value} />
                                        </Col>
                                    </div>
                                    <div className="row">
                                        <div className="form-group" >
                                            <textarea className="form-control" placeholder="نشانی طرف حساب" onChange={e => customerData.current.Address = e.target.value} />
                                            {err.Address && <small className="errors">نشانی اجباری است</small>}
                                        </div>
                                    </div>
                                    <div className="mt-1" style={{ margin: "auto" }}>
                                        <Button className='group-Btn' variant='success' onClick={() => submit()} disabled={isPending}> <CheckLg size={17} />&nbsp;ثبت سریع</Button>
                                        <Button className='group-Btn' onClick={() => submit(true)} variant='info' disabled={isPending}><Check2All size={18} />&nbsp;ثبت و تکمیل اطلاعات</Button>
                                    </div>

                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    }
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "rgb(30 165 187)" }}>
                            <Search size={18} />
                            &nbsp;
                            جستجوی {title}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <form onSubmit={handleSubmit(search)}>
                                    <div className="row mt-2">
                                        <div className="form-group col-md-4  mt-0">
                                            <input type="text" placeholder="کد حساب" className="form-control tableRowInput" name="Code" ref={register({})} />
                                        </div>
                                        {!invoiceCustomers && <>
                                            <div className="form-group col-md-4  mt-0">
                                                <input type="text" placeholder="کد ملی" className="form-control tableRowInput" name="NationalCode" ref={register({})} />
                                            </div>
                                            <div className="form-group col-md-4  mt-0">
                                                <input type="text" placeholder="کد اشتراک" className="form-control tableRowInput" name="SubscriptionCode" ref={register({})} />
                                            </div>
                                        </>}
                                        <div className="form-group col-md-4  mt-0">
                                            <input id="inputCustName" type="text" placeholder="نام/نام خانوادگی" className="form-control tableRowInput"
                                                name={invoiceCustomers ? "Name" : "NameOrFirstName"} ref={register({})} onKeyDown={inputKeyDown} />
                                        </div>

                                        <div className="form-group col-md-4 mt-0">
                                            <input type="number" placeholder="شماره تلفن/همراه" className="form-control tableRowInput"
                                                name="Mobile" ref={register({})} onKeyDown={inputKeyDown} />
                                        </div>
                                        <div className="form-group col-md-4 mt-0">
                                            <input type="text" placeholder="نشانی" className="form-control tableRowInput"
                                                name="Address" ref={register({})} onKeyDown={inputKeyDown} />
                                        </div>
                                        <div className="form-group col-md-4 mt-0" >
                                            <select className="form-control tableRowInput" name="CustomerAccountType" ref={register({})} defaultValue={defaultAccType === undefined ? true : defaultAccType}>
                                                <option value="">ماهیت حساب را انتخاب کنید</option>
                                                <option value={true}>بدهکار </option>
                                                <option value={false}>بستانکار </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary w-100 mt-2 mb-1"><Search />&nbsp;&nbsp;جستجوی {title}</button>
                                </form>
                                {/* <Table className="mt-1" responsive style={{ whiteSpace: "nowrap" }}>
                                    <thead>
                                        <tr>
                                            <th>کد {title}</th>
                                            <th>نام {title}</th>
                                            <th>تلفن/موبایل</th>
                                            {isWebApp() &&
                                                <>
                                                    <th>کد ملی</th>
                                                    <th>کد اشتراک</th>
                                                </>}
                                            {invoiceCustomers && <th>نوع</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customerList === "PENDING" &&
                                            <tr><td colSpan={invoiceCustomers ? 6 : 5} style={{ textAlign: "center", color: "red" }}>
                                                <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={30} width={30} />
                                            </td></tr>
                                        }
                                        {customerList?.Error &&
                                            <tr>
                                                <td colSpan={invoiceCustomers ? 6 : 5} style={{ textAlign: "center", color: "red" }}>{customerList.Error}</td>
                                            </tr>
                                        }
                                        {customerList?.Data && Array.isArray(customerList.Data) &&
                                            customerList.Data.map((item, i) => {
                                                return (
                                                    <tr className='resultTableRow' style={{ backgroundColor: i % 2 === 0 ? "white" : "#e9e9e9", color: item.IsBlackListed ? "red" : "unset" }} key={i} onClick={() => select(item)}>
                                                        <td style={{ display: "none" }}></td>
                                                        <td>{item.Code}</td>
                                                        <td>{item.FirstName} {item.Name}</td>
                                                        <td>{(item.Phone || item.Mobile) ? (item.Phone ?? "-") + '/' + (item.Mobile ?? "-") : "-"}</td>
                                                        {isWebApp() &&
                                                            <>
                                                                <td>{item.NationalCode}</td>
                                                                <td>{item.SubscriptionCode}</td>
                                                            </>}
                                                        {invoiceCustomers && <td>{item.CustOrPreCust}</td>}
                                                    </tr>)
                                            })}
                                    </tbody>
                                </Table> */}
                                <BihamtaTable columns={tableCols} dataList={customerList} maxHeight={200} style={{whiteSpace:"nowrap"}} 
                                rowClick={select}/>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCustomer;